import { Button } from '@/components/ui/button';
import { Plus } from 'lucide-react';
import { useNavigate } from "react-router-dom";
import { BillingDraftsTable } from '~/components/billing-drafts/BillingDraftsTable';
import Content from "../components/layout/Content";

const BillingDrafts = () => {
    const navigate = useNavigate();

    return (
        <Content>
            <div className='container mx-auto py-10'>
                <div className='flex justify-between items-center mb-6'>
                    <h1 className='text-2xl font-bold'>Aufträge</h1>
                    <Button onClick={() => navigate('/billing-draft/new')}>
                        <Plus className='mr-2 h-4 w-4' />
                        Neuer Auftrag
                    </Button>
                </div>

                <BillingDraftsTable />
            </div>
        </Content>
    );
};

export default BillingDrafts;
